import { connect } from 'react-redux';

import { CompositeSessionInfoSelectors } from '../app/selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '../app/selectors/SiteUrlsSelectors';
import { AppState } from '../app/state/AppState';
import { MapStateToProps } from '../app/utils/ConnectUtils';
import { ConnectedCatalogBrowserHostProps, WrappedCatalogBrowserHost } from './CatalogBrowserHost';

const mapStateToProps: MapStateToProps<ConnectedCatalogBrowserHostProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state),
  areUsersVisible: !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state)
});

export const ConnectedCatalogBrowserHost = connect(mapStateToProps)(WrappedCatalogBrowserHost);
